import React, { useState } from "react";

export const Context2 = React.createContext();

function getCookie(name) {
  const value = `;${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }
}

const Audio = ({ children }) => {
  const [playing, setPlaying] = useState(() => {
    const cookie = getCookie("audio");

    return cookie === undefined ? true : cookie === "true";
  });

  return (
    <Context2.Provider value={[playing, setPlaying]}>
      {children}
    </Context2.Provider>
  );
};

export default Audio;
